import strophe from 'strophe'
import {
  projectVar
} from '../config/env'
var privateChatConnect;
var closedPrivateChatConnectIntented;
var room;
var privateChatConnectReconnectTimeOut;
var publicChatConnect;
var closedPublicChatConnectIntented;
var publicChatConnectReconnectTimeOut;
var publicChatRoomid;
var sendPresenceTimer;
export function connectPublicChatServer(serverUrl, roomid, name, password, receivingMessageCallback, connectionStateCallBack, conectionSuccessCallBack) {
  closedPublicChatConnectIntented = false;
  //消息回调
  var messageListener = function (elem) {
    handleReceivingPublicMessage(elem, receivingMessageCallback);
  };
  //连接状态
  var connectionState = function (state) {
    connectionStateCallBack(state);
  };
  var conectionSuccessCallBackFunction = function () {
    conectionSuccessCallBack();
  };
  publicChatRoomid = roomid;
  newPublicChatConnect(serverUrl, name, password, messageListener, connectionState, conectionSuccessCallBackFunction);
}

export function newPublicChatConnect(serverUrl, name, password, messageListener, connectionState, conectionSuccessCallBack) {
  clearTimeout(publicChatConnectReconnectTimeOut);
  publicChatConnect = new Strophe.Connection(serverUrl);
  publicChatConnect.connect(name, password, function (status) {
    if (Strophe.Status.CONNECTED == status) {
      publicChatConnect.xmlInput = messageListener;
      consoleDebugMessage("public chat Openfire建立连接成功！");
      //发送出席
      sendPresence(publicChatConnect);
      if(sendPresenceTimer){
        clearInterval(sendPresenceTimer);
      }
      sendPresenceTimer = setInterval(function () {
        sendPresence(publicChatConnect);
      }, 30 * 1000);
      //连接成功后回调
      conectionSuccessCallBack();
    } else if (Strophe.Status.DISCONNECTED == status && !closedPrivateChatConnectIntented) {
      publicChatConnectReconnectTimeOut = setTimeout(function () {
        newPublicChatConnect(serverUrl, name, password, messageListener, null);
      }, 3 * 1000);
    }
    if (connectionState) {
      connectionState(status);
    }
  });
}
/*私信*/
export function connectPrivateChatServer(serverUrl, roomid, role, uid, password, receivingMessageCallback, connectionStateCallBack) {
  closedPrivateChatConnectIntented = false;
  //消息回调
  var messageListener = function (elem) {
    handleReceivingMessage(elem, receivingMessageCallback);
  }
  //连接状态
  var connectionState = function (state) {
    connectionStateCallBack(state);
  }
  room = roomid;
  var resourceID = projectVar.opSpace + '_' + projectVar.opTerminal + '_' + projectVar.opVersion + '_' + roomid + '_' + role;
  var name = uid + '@' + projectVar.opProDomain + "/" + resourceID;
  newPrivateChatConnect(serverUrl, name, password, messageListener, connectionState);
}

export function newPrivateChatConnect(serverUrl, name, password, messageListener, connectionState) {
  clearTimeout(privateChatConnectReconnectTimeOut);
  privateChatConnect = new Strophe.Connection(serverUrl);
  privateChatConnect.connect(name, password, function (status) {
    if (Strophe.Status.CONNECTED == status) {
      privateChatConnect.xmlInput = messageListener;
      consoleDebugMessage("Openfire建立连接成功！");
      sendPresence(privateChatConnect);
    } else if (Strophe.Status.DISCONNECTED == status && !closedPrivateChatConnectIntented) {
      privateChatConnectReconnectTimeOut = setTimeout(function () {
        newPrivateChatConnect(serverUrl, name, password, messageListener, null);
      }, 3 * 1000);
    }
    if (connectionState) {
      connectionState(status);
    }
  });
}
/**
 * 发送出席
 */
export function sendPresence(conn) {
  if (!!conn) {
    consoleDebugMessage("发送出席");
    conn.send($pres());
  }
}

export function sendMessage(jsonObj, toUid) {
  if (!!privateChatConnect) {
    var jsonStr = $.toJSONString(jsonObj);
    var iq = $msg({type: 'chat', to: toUid + "@openfire.cn"}).c('body', {}).t('' + jsonStr);
    privateChatConnect.send(iq);
    consoleDebugMessage("发送消息:" + jsonStr);
  }
}
export function sendPublicChatMessage(jsonObj) {
  if (!!publicChatConnect) {
    var jsonStr = JSON.stringify(jsonObj);
    var iq = $iq({type: 'set'}).c('request', {xmlns: "jabber:iq:showspace"}).t('<![CDATA[' + jsonStr + ']]>');
    publicChatConnect.send(iq);
    consoleDebugMessage("publicChatConnect 发送消息:" + jsonStr);
  }
}

/**
 * 处理回调消息
 */
export function handleReceivingPublicMessage(xmlElement, callback) {
  var xmlStr = null;
  if (xmlElement !== null && xmlElement.textContent !== null) {
    xmlStr = xmlElement.textContent;
  }
  if (xmlStr === null) {
    return;
  }
  var jsonObj = publicMessageToJson(xmlStr);
  if (!!jsonObj && jsonObj.type != null) {
    callback(jsonObj);
  }
}
/**
 * 处理回调消息
 */
export function handleReceivingMessage(xmlElement, callback) {
  var xmlStr = null,
    fromUid,
    source;
  if (xmlElement !== null && xmlElement.textContent !== null) {
    xmlStr = xmlElement.textContent;
  }
  if (xmlStr === null) {
    return;
  }
  //parse from uid
  if (xmlElement && xmlElement.outerHTML) {
    source = xmlElement.outerHTML;
    fromUid = source.match(/from="(\d*)@/)[1];
  }
  var jsonObj = messageToJson(xmlStr);
  if (!!jsonObj && jsonObj.type != null) {
    if (!jsonObj.hasOwnProperty('fromUid')) {
      jsonObj.fromUid = fromUid;
    }
    consoleDebugMessage("接收消息:" + jsonObj.type + " " + jsonObj.subtype);
    consoleDebugMessage("消息内容:" + JSON.stringify(jsonObj));
    callback(jsonObj);
  }
}
/**
 * 处理消息内容
 */
export function messageToJson(xmlStr) {
  var browserName = navigator.appName;
  var strDecoded;
  if (browserName == "Microsoft Internet Explorer") {//IE
    strDecoded = regHtml(xmlStr);
  } else {
    strDecoded = $('<textarea/>').html(xmlStr).val();
  }
  var strTrimed = strDecoded.replace("<![CDATA[", "");
  strTrimed = strTrimed.replace("]]>", "");
  var jsonObj;
  if (strTrimed != null && strTrimed.length > 0 && strTrimed.indexOf("{") > -1) {
    try {
      jsonObj = JSON.parse(strTrimed);
    }
    catch (e) {
      consoleDebugMessage("json 解析失败 str=" + strTrimed);
    }
  }
  return jsonObj;
}
/**
 * 处理消息内容
 */
export function publicMessageToJson(xmlStr) {
  var browserName = navigator.appName;
  var strDecoded;
  if (browserName == "Microsoft Internet Explorer") {//IE
    strDecoded = regHtml(xmlStr);
  } else {
    // strDecoded = $('<textarea/>').html(xmlStr).val();
    strDecoded = xmlStr;
  }
  var strTrimed = strDecoded.replace("<![CDATA[", "");
  strTrimed = strTrimed.replace("]]>", "");
  var jsonObj;
  if (strTrimed != null && strTrimed.length > 0 && strTrimed.indexOf("{") > -1) {
    jsonObj = JSON.parse(strTrimed);
  }
  return jsonObj;
}

export function isPrivateConnected() {
  return !!privateChatConnect && privateChatConnect.connected;
}

export function isPublicChatConnected() {
  return !!publicChatConnect && publicChatConnect.connected;
}

export function disConnectServer() {
  if (privateChatConnect) {
    privateChatConnect.disconnect();
  }
  if (publicChatConnect) {
    publicChatConnect.disconnect();
  }
  closedPrivateChatConnectIntented = true;
  closedPublicChatConnectIntented = true;
  consoleDebugMessage("Openfire disconnected!");
}
export function consoleDebugMessage(message) {
  //console.log(message);
}
jQuery.extend({
  toJSONString: function (object) {
    var type = typeof object;
    if ('object' == type) {
      if (Array == object.constructor) type = 'array';
      else if (RegExp == object.constructor) type = 'regexp';
      else type = 'object';
    }
    switch (type) {
      case 'undefined':
      case 'unknown':
        return;
      case 'function':
      case 'boolean':
      case 'regexp':
        return object.toString();
      case 'number':
        return isFinite(object) ? object.toString() : 'null';

      case 'string':
        return '"' + object.replace(/(\\|\")/g, "\\$1").replace(/\n|\r|\t/g, function () {
          var a = arguments[0];
          return (a == '\n') ? '\\n' : (a == '\r') ? '\\r' : (a == '\t') ? '\\t' : "";
        }) + '"';

      case 'object':
        if (object === null) return 'null';
        var results = [];
        for (var property in object) {
          var value = jQuery.toJSONString(object[property]);
          if (value !== undefined) results.push(jQuery.toJSONString(property) + ':' + value);
        }
        return '{' + results.join(',') + '}';
      case 'array':
        var results1 = [];
        for (var i = 0; i < object.length; i++) {
          var value1 = jQuery.toJSONString(object[i]);
          if (value1 !== undefined) results1.push(value1);
        }
        return '[' + results1.join(',') + ']';
    }
  }
});
export default {
  sendMessage,
  disConnectServer,
  isPrivateConnected,
  connectPublicChatServer,
  isPublicChatConnected,
  sendPublicChatMessage,
  connectPrivateChatServer
}



// WEBPACK FOOTER //
// ./src/common/websocketSrv.js